<template>
    <ul>
        <li v-for="genre in options" :key="genre[idField]">
            <label class="hasChildren font-7" @click="toggle(genre[idField])"
                   :class="{'open': menuOpen[genre[idField]] }">
                <span class="title">
                    {{genre[displayField]}}
                </span>
                <span class="arrow-dropdown">
                    <IconBase height="8px" width="8px" icon-name="arrowRightIcon"/>
                </span>
            </label>
            <leavesDropdown v-if="menuOpen[genre[idField]]" :options="genre.childOptions"
                            :id-field="idField"
                            :display-field="displayField"
                            :selected-item="selectedItem"
            @dropdownSelectedOption="$emit('dropdownLeafSelected', {event: $event, selectedGenre: genre[idField]})">
            </leavesDropdown>
        </li>
    </ul>
</template>

<script>
import IconBase from '../IconBase.vue';
import LeavesDropdown from './LeavesDropdown.vue';

export default {
    name: 'TreeDropdownItem',
    components: {
        LeavesDropdown,
        IconBase
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        displayField: String,
        idField: String,
        selectedItem: Object,
        selectedGenre: String
    },
    created() {
        if (this.selectedGenre) {
            this.toggle(this.selectedGenre);
        }
    },
    data() {
        return {
            menuOpen: {}
        };
    },
    methods: {
        toggle(genreId) {
            this.menuOpen = { ...this.menuOpen, ...{ [genreId]: !this.menuOpen[genreId] } };
        }
    }
};
</script>

<style scoped lang="scss">
    @import './dropdownStyleGuide';

    $elementHeight: 32px;
    $paddingLeftElements: 8px;

    .hasChildren {
        line-height: $elementHeight;
        padding-top: 4px;
        cursor: pointer;
        display: block;
        position: relative;
        background-color: $white;
        color: $light-900;

        &:hover {
            background-color: $light-100;
        }

        .title {
            color: $light-800;
            padding: 7px $paddingLeftElements;
        }
    }
    .arrow-dropdown {
        fill: $dark-300;
        position: absolute;
        right: 11px;
    }

    .open {
        .arrow-dropdown {
            transform: rotate(90deg);
        }
    }
</style>
